import { render, staticRenderFns } from "./FireLedger.vue?vue&type=template&id=0a05b568&scoped=true"
import script from "./FireLedger.vue?vue&type=script&lang=js"
export * from "./FireLedger.vue?vue&type=script&lang=js"
import style0 from "./FireLedger.vue?vue&type=style&index=0&id=0a05b568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05b568",
  null
  
)

export default component.exports